import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { type RowPendingClient } from 'entities/Clients/model/RowPendingClient'
import { useClientsViewContext } from 'pages/clients/context/clientsPageContext'
import { ClientsTable } from 'pages/clients/ui/ClientsTable/ClientsTable'
import { getPendingClientRowActions } from 'pages/clients/ui/actions/getPendingClientRowActions'
import { pendingClientsColumns } from './columns'

export const PendingClientsTab = observer(() => {
  const { pendingClientsTabStore } = useClientsViewContext()
  const { tableStore, itemsRows, init, scrollToTopTrigger, dispose, onSuccessCancelInvite } =
    pendingClientsTabStore

  useEffect(() => {
    init()
    return () => {
      dispose()
    }
  }, [])

  const rows = itemsRows.map((row) => {
    row.setActionsProps({
      actions: getPendingClientRowActions(row, onSuccessCancelInvite),
    })

    return row
  })

  return (
    <ClientsTable<RowPendingClient>
      tableStore={tableStore}
      rows={rows}
      columns={pendingClientsColumns}
      scrollToTopTrigger={scrollToTopTrigger}
    />
  )
})
